/* mm-landing — comportamiento del clon de Magic Mind.
   Réplica de sus interacciones: typewriter del hero (50 ms por carácter,
   1 s de pausa), carruseles de testimonios e ingredientes (flechas, puntos,
   arrastre y bucle), acordeón de FAQ (200 ms) y scroll a la buy box.
   Idempotente: se puede llamar varias veces (dos instancias de la sección y
   el evento shopify:section:load del editor). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Typewriter ---------- */
  function typewriter(el) {
    if (el.__mm) return; el.__mm = 1;
    var txt = el.querySelector('.mm-tw__txt');
    var words = (el.getAttribute('data-words') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!txt || !words.length || reduce) return;
    var wi = 0, ci = words[0].length, typing = false, hold = 0;
    var TICK = 50, HOLD = 1000;
    function step() {
      var w = words[wi];
      if (typing) {
        if (ci < w.length) { ci++; txt.textContent = w.slice(0, ci); }
        else { typing = false; hold = HOLD; }
      } else if (hold > 0) {
        hold -= TICK;
      } else if (ci > 0) {
        ci--; txt.textContent = w.slice(0, ci);
      } else {
        wi = (wi + 1) % words.length; typing = true;
      }
    }
    hold = HOLD * 2;
    el.__mmTimer = setInterval(step, TICK);
  }

  /* ---------- Carrusel ---------- */
  function slider(root) {
    if (root.__mm) return; root.__mm = 1;
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelectorAll('[data-prev]'), next = root.querySelectorAll('[data-next]');
    var dotsBox = root.querySelector('[data-dots]');
    var loop = root.getAttribute('data-loop') !== 'false';
    var index = 0, dots = [];

    function perView() {
      var vp = track.parentElement.getBoundingClientRect().width;
      var sw = slides[0] ? slides[0].getBoundingClientRect().width : vp;
      return Math.max(1, Math.floor((vp + 1) / Math.max(1, sw)));
    }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function offsetOf(i) {
      if (!slides[i]) return 0;
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }
    function render() {
      track.style.transform = 'translate3d(' + (-offsetOf(index)) + 'px,0,0)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (!loop) {
        Array.prototype.forEach.call(prev, function (b) { b.disabled = index <= 0; });
        Array.prototype.forEach.call(next, function (b) { b.disabled = index >= maxIndex(); });
      }
    }
    function go(i) {
      var m = maxIndex();
      if (loop) { i = i > m ? 0 : (i < 0 ? m : i); } else { i = Math.min(m, Math.max(0, i)); }
      index = i; render();
    }
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = ''; dots = [];
      for (var i = 0; i <= maxIndex(); i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mm-dot'; b.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
        dotsBox.appendChild(b); dots.push(b);
      }
    }
    Array.prototype.forEach.call(prev, function (b) { b.addEventListener('click', function () { go(index - 1); }); });
    Array.prototype.forEach.call(next, function (b) { b.addEventListener('click', function () { go(index + 1); }); });

    // Arrastre / swipe
    var x0 = null, y0 = 0, dx = 0, base = 0, locked = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; y0 = e.clientY; dx = 0; locked = null; base = -offsetOf(index);
    });
    window.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (locked === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) locked = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      if (locked !== 'x') return;
      dx = mx; track.classList.add('is-dragging');
      track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    });
    function end() {
      if (x0 === null) return;
      track.classList.remove('is-dragging');
      if (locked === 'x' && Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1)); else render();
      x0 = null;
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (Math.abs(dx) > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Misma altura para todas las tarjetas del carrusel (la de la más alta)
    var cards = root.querySelectorAll('[data-eq]');
    function equalize() {
      if (!cards.length) return;
      var max = 0;
      Array.prototype.forEach.call(cards, function (c) { c.style.minHeight = ''; });
      Array.prototype.forEach.call(cards, function (c) { max = Math.max(max, c.offsetHeight); });
      Array.prototype.forEach.call(cards, function (c) { c.style.minHeight = max + 'px'; });
    }
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { equalize(); buildDots(); go(Math.min(index, maxIndex())); }, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalize);
    window.addEventListener('load', equalize);
    equalize(); buildDots(); render();
  }

  /* ---------- Acordeón ---------- */
  function accordion(item) {
    if (item.__mm) return; item.__mm = 1;
    var q = item.querySelector('.mm-faq__q'), a = item.querySelector('.mm-faq__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      if (open) {
        a.style.height = a.scrollHeight + 'px';
        requestAnimationFrame(function () { a.style.height = '0px'; });
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');
        a.style.height = '0px';
        requestAnimationFrame(function () { a.style.height = a.scrollHeight + 'px'; });
        a.addEventListener('transitionend', function te() { if (item.classList.contains('is-open')) a.style.height = 'auto'; a.removeEventListener('transitionend', te); });
      }
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---------- CTA → buy box ---------- */
  function buyTarget() {
    return document.querySelector('[id$="__producto"]') ||
      document.querySelector('.shopify-section form[action*="/cart/add"]');
  }
  function bindCta(a) {
    if (a.__mm) return; a.__mm = 1;
    a.addEventListener('click', function (e) {
      var t = buyTarget(); if (!t) return;
      e.preventDefault();
      // 80 px como siempre; 16 px solo si la página oculta la cabecera (casilla «Ocultar cabecera»)
      var hdr = document.querySelector('.shopify-section-group-header-group.shopify-section--header');
      var off = (hdr && hdr.offsetParent === null) ? 16 : 80;
      var top = t.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.mm-lp .mm-tw'), typewriter);
    Array.prototype.forEach.call(scope.querySelectorAll('.mm-lp [data-mm-slider]'), slider);
    Array.prototype.forEach.call(scope.querySelectorAll('.mm-lp .mm-faq__item'), accordion);
    Array.prototype.forEach.call(scope.querySelectorAll('.mm-lp a[href="#comprar"]'), bindCta);
  }
  window.MMLanding = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
